import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, flow, observable, runInAction } from "mobx";
import moment from "moment";
import { BaseOptions } from "@devowl-wp/utils";
const DATE_FORMAT = "YYYY-MM-DD";
class StatsStore extends BaseOptions {
    constructor(rootStore){
        super();
        this.busyStats = {
            main: false,
            buttonClicked: false,
            customBypass: false
        };
        this.stats = observable.object({
            main: undefined,
            buttonsClicked: undefined,
            customBypass: undefined
        }, {}, {
            deep: false
        });
        this.filters = observable.object({
            dates: undefined,
            context: undefined
        }, {}, {
            deep: false
        });
        this.fetchMain = flow(function*() {
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        });
        this.fetchButtonsClicked = flow(function*() {
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        });
        this.fetchCustomBypass = flow(function*() {
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        });
        this.rootStore = rootStore;
        runInAction(()=>{
            this.filters.dates = [
                moment().subtract(30, "days"),
                moment()
            ];
            this.filters.context = this.rootStore.optionStore.others.context;
        });
    }
    /**
     * This action does not actually refetch the stats, you need to act on your components!
     *
     * @param dates
     */ applyDates(dates) {
        this.filters.dates = dates;
    }
    /**
     * This action does not actually refetch the stats, you need to act on your components!
     *
     * @param context
     */ applyContext(context) {
        this.filters.context = context;
    }
}
_ts_decorate([
    observable
], StatsStore.prototype, "busyStats", void 0);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], StatsStore.prototype, "applyDates", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], StatsStore.prototype, "applyContext", null);
export { StatsStore };
